import React, { Component } from 'react';
import '../css/bulma.css'
import './estilo.css'

const customStyles = {
    content: {
        height: '100%',
        width: '100%',
        textAling: 'center'
    }
};

const customStyles2 = {
    content: {
        width: '100%',
        bacgroudColor: 'red'
    }
};


export default class Report extends Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }


    render() {
        return (
            <div>
                <div className="container">
                    <div className="columns">
                        <div className="column is-5 is-offset-1">
                            <h2 className="is-size-5" id="id">¡Gracias por preferirnos!</h2>
                        </div>
                        <div className="column is-offset-2">
                            <img src="https://firebasestorage.googleapis.com/v0/b/acacya-2017v1.appspot.com/o/Reportes%2Flogo.png?alt=media&token=eeeccafa-a627-4082-bcf0-ee944bdcd425" width="75" height="75" />
                        </div>
                    </div>
                </div>
                <br />
                <section className="column is-10 is-offset-1 hero is-info is-small">
                    <div className="hero-body">
                        <div className="container">
                            <h2 className="subtitle is-size-4">
                                {this.props.datos.total} | {this.props.datos.pago}
                            </h2>
                            <h2 className="subtitle is-size-6">
                                {this.props.datos.fechaBajada} | {this.props.datos.tipoV}
                            </h2>
                        </div>
                    </div>
                </section>
                <div className="columns">
                    <div className="column is-10 is-offset-1">
                        <img src="https://maps.googleapis.com/maps/api/staticmap?size=543x100&scale=2&markers=color:green%7Clabel:O%7C13.70364459,-89.24474971&markers=color:red%7Clabel:D%7C13.6769907,-89.2543446&key=AIzaSyDY4AY7Ih1yS8M7Jh4f5eupcLX4tB9GcLg" alt="" />
                    </div>
                </div>
                <div className="columns">
                    <div className="column is-10 is-offset-1">
                        <div className="box">
                            <div className="columns">
                                <div className="column">
                                    <p className="is-size-6"><img src="https://firebasestorage.googleapis.com/v0/b/acacya-2017v1.appspot.com/o/Reportes%2Fo.png?alt=media&token=40295272-03ca-4251-8552-dd18ca6e2534" width="20" height="20" />&nbsp;{this.props.datos.lugar}</p>
                                    <p className="is-size-6"><img src="https://firebasestorage.googleapis.com/v0/b/acacya-2017v1.appspot.com/o/Reportes%2Fd.png?alt=media&token=bef91d40-19c6-42f1-ac9f-a8d4638be9d4" width="20" height="20" /> &nbsp;{this.props.datos.desde}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="column is-10 is-offset-1">
                        <div className="box">
                            <div className="columns">
                                <div className="column is-one-quarter">
                                    <img className="imgRedon" src={this.props.datos.foto} width="50" height="50" />
                                </div>
                                <div className="column">
                                    <p className="is-size-7 has-text-weight-bold">Su conductor:</p>
                                    <p className="is-size-7">Nombre: {this.props.datos.empleado}</p>
                                    <p className="is-size-7">Placa: {this.props.datos.vehiculo}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Reportes/repoViaje.js